import { useAppData } from "../../App";

const ContactMessage: React.FC<{}> = () => {
  const appData = useAppData();
  const contactMessage = appData.carrier.CustomMessages?.ContactMessage;
  const contactEmail = appData.carrier.CustomMessages?.ContactEmail;
  const contactPhone = appData.carrier.CustomMessages?.ContactPhone;
  // TODO: add default/fallback message if contactMessage is undefined?
  return (
    <div className="contact-message">
      <p>{ contactMessage }</p>
      <p><a href={'tel: ' + contactPhone}>{ contactPhone }</a></p>
      <p><a href={'mailto:' + contactEmail}>{ contactEmail }</a></p>
    </div>
  );
};

export default ContactMessage;